import { BrandMark } from "@/components/BrandMark";
export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative mx-auto w-full max-w-[1400px] border-t border-[#333] px-6 py-8 md:px-10 md:py-12"
    >
      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <BrandMark size="md" />
          <p className="mt-6 font-mono-stamp text-xs text-[#a0a0a0]">
            ONE DROP. ALL VIBE. NO LABELS.
          </p>
        </div>

        <div className="col-span-6 md:col-span-2">
          <p className="font-mono-stamp text-[10px] text-[#555]">▸ SHOP</p>
          <ul className="mt-4 space-y-2 font-mono-stamp text-xs">
            <li><a href="/" className="hover:text-white text-[#a0a0a0]">THE DROP</a></li>
            <li><a href="/find-your-fit" className="hover:text-white text-[#a0a0a0]">FIND YOUR FIT</a></li>
            <li><a href="#" className="hover:text-white text-[#a0a0a0]">ARCHIVE</a></li>
          </ul>
        </div>

        <div className="col-span-6 md:col-span-2">
          <p className="font-mono-stamp text-[10px] text-[#555]">▸ INFO</p>
          <ul className="mt-4 space-y-2 font-mono-stamp text-xs">
            <li><a href="#manifesto" className="hover:text-white text-[#a0a0a0]">MANIFESTO</a></li>
            <li><a href="#" className="hover:text-white text-[#a0a0a0]">SHIPPING</a></li>
            <li><a href="#" className="hover:text-white text-[#a0a0a0]">RETURNS</a></li>
          </ul>
        </div>

        <div className="col-span-12 md:col-span-3">
          <p className="font-mono-stamp text-[10px] text-[#555]">▸ CONTACT</p>
          <p className="mt-4 font-mono-stamp text-xs text-[#a0a0a0]">
            HEY@BAS1C.WORLD
          </p>
          <p className="mt-2 font-mono-stamp text-xs text-[#a0a0a0]">
            SYDNEY / REMOTE
          </p>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-2 border-t border-[#222] pt-6 md:flex-row md:items-center md:justify-between">
        <p className="font-mono-stamp text-[10px] text-[#555]">
          © 2025 BAS1C THE BRAND. EVERY ITEM HAND-STAMPED.
        </p>
        <p className="font-mono-stamp text-[10px] text-[#555]">
          RUN TAG PROTOCOL v1.0
        </p>
      </div>
    </footer>
  );
};
